<script lang="ts" setup>
import "../public/fonts/stylesheet.scss";
import { useRoute } from "vue-router";
import { computed } from "vue";
import PaymentModal from "@/components/PaymentModal.vue";
import LanguageSwitcher from "@/components/base/LanguageSwitcher.vue";
import { useStore } from "vuex";
import BaseModal from "@/components/base/BaseModal.vue";
import { ModalConfigStruct } from "@/struct/ui/UIModalStruct";

const route = useRoute();
const store = useStore();

const layoutComponent = computed(() => {
  return route.meta.layout || "main-layout";
});

const showPaymentModal = computed(() => {
  return store.getters.showPaymentModal;
});

const closePaymentModal = () => {
  store.dispatch("togglePaymentModal", false);
};

const brandId = computed(() => store.state.brand.operatorSource);

const modalConfig = computed<ModalConfigStruct | null>(
  () => store.state.system.activeConfig
);

const closeModal = () => store.dispatch("system/closeModal");

const handleAction = () => {
  if (modalConfig.value?.onAction) modalConfig.value.onAction();
  closeModal();
};

const handleSecondaryAction = () => {
  if (modalConfig.value?.onSecondaryAction)
    modalConfig.value.onSecondaryAction();
  closeModal();
};
</script>

<template>
  <div class="root" :data-theme="brandId">
    <LanguageSwitcher :is-visible="false" />
    <component :is="layoutComponent">
      <router-view />
    </component>
    <BaseModal
      v-if="modalConfig"
      v-bind="modalConfig"
      @close="closeModal"
      @action="handleAction"
      @secondary-action="handleSecondaryAction"
    />
    <PaymentModal :show-modal="showPaymentModal" @close="closePaymentModal" />
  </div>
</template>

<style lang="scss">
@import "assets/style/main";

.root {
  position: relative;
  min-height: 100vh;
}
</style>

<style lang="scss" scoped>
@import "assets/style/themes";

.root {
  @include render-themes;
}
</style>
